// Small phone-number utilities used across the app.
// The platform mandates E.164-style international numbers starting with "+",
// followed by 7-15 digits (spaces / dashes / parentheses are stripped for the
// length check but stay in the stored value for display).

export function normalisePhone(v) {
  return String(v || "").trim().replace(/\s+/g, " ");
}

export function isValidPhone(raw) {
  if (typeof raw !== "string") return false;
  const s = raw.trim();
  if (!s.startsWith("+")) return false;
  const digits = s.replace(/[^0-9]/g, "");
  return digits.length >= 7 && digits.length <= 15;
}

export function phoneError(raw) {
  if (typeof raw !== "string" || !raw.trim()) return "Phone number is required";
  const s = raw.trim();
  if (!s.startsWith("+")) return "Number must start with a + country code (e.g. +233…)";
  const digits = s.replace(/[^0-9]/g, "");
  if (digits.length < 7) return "Number is too short — include the country code and full number";
  if (digits.length > 15) return "Number is too long";
  // Allow only digits, spaces, dashes, parentheses after the "+"
  if (!/^\+[0-9()\-\s]+$/.test(s)) return "Only digits, spaces, dashes and parentheses are allowed";
  return null;
}
